const unixToDateTimeUtils = (unixTimestamp) =>{
    let date = new Date(unixTimestamp * 1000);
    return date
}

export default unixToDateTimeUtils